import { render, staticRenderFns } from "./ShowCollectors.vue?vue&type=template&id=7bad3a86&"
import script from "./ShowCollectors.vue?vue&type=script&lang=js&"
export * from "./ShowCollectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports